import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function SiteFooter() {
  const { user } = useAuth();
  return (
    <footer
      data-testid="site-footer-copyright"
      className="border-t border-brand-line bg-brand-bone no-print"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-brand-muted">
        <div className="flex items-center gap-2 text-center sm:text-left">
          <span>© 2026 High Vibe Pinnacle Pictures. All rights reserved.</span>
        </div>
        <div className="flex items-center gap-5">
          {user && (
            <Link to="/pricing" className="hover:text-brand-forest transition-colors">
              Pricing
            </Link>
          )}
          <Link to="/quick-breakdown" className="hover:text-brand-forest transition-colors">
            Public breakdown
          </Link>
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-brand-forest transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-brand-forest transition-colors">
            Terms &amp; Conditions
          </Link>
          <span className="hidden sm:inline text-brand-muted/60">
            Build A Bank · IBC Calculator
          </span>
        </div>
      </div>
    </footer>
  );
}
